import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const PersonCircle = ({
  width = '25',
  height = '25',
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 0C3.86 0 0.5 3.36 0.5 7.5C0.5 11.64 3.86 15 8 15C12.14 15 15.5 11.64 15.5 7.5C15.5 3.36 12.14 0 8 0ZM8 2.25C9.245 2.25 10.25 3.255 10.25 4.5C10.25 5.745 9.245 6.75 8 6.75C6.755 6.75 5.75 5.745 5.75 4.5C5.75 3.255 6.755 2.25 8 2.25ZM8 12.9C7.1089 12.9 6.23164 12.6795 5.44646 12.2581C4.66128 11.8367 3.99258 11.2276 3.5 10.485C3.5225 8.9925 6.5 8.175 8 8.175C9.4925 8.175 12.4775 8.9925 12.5 10.485C12.0074 11.2276 11.3387 11.8367 10.5535 12.2581C9.76836 12.6795 8.8911 12.9 8 12.9Z" />
  </IconSvg>
)

export default PersonCircle
